import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useAppSelector } from '../../store';
import { selectIsUserAdminOrHigher } from '../../store/general/general-slice-selectors';

const SwitchInput: React.FC<{
  label: React.ReactNode;
  isChecked: boolean;
  onChange: () => void;
  size?: 'small' | 'medium';
  adminOnly?: boolean;
  disabled?: boolean;
}> = ({ label, isChecked, size, adminOnly, disabled, onChange }) => {
  const isAdmin = useAppSelector((state) => selectIsUserAdminOrHigher(state));

  return (
    <FormControlLabel
      control={<Switch checked={isChecked} onChange={onChange} size={size} />}
      disabled={(!isAdmin && adminOnly) || disabled}
      label={label}
      sx={(theme) => ({
        minHeight: theme.spacing(7),
        display: 'inline-flex',
        alignContent: 'center',
      })}
    />
  );
};

export default SwitchInput;
